import { render, staticRenderFns } from "./VersoesList.vue?vue&type=template&id=234c48da"
import script from "./VersoesList.vue?vue&type=script&lang=js"
export * from "./VersoesList.vue?vue&type=script&lang=js"
import style0 from "./VersoesList.vue?vue&type=style&index=0&id=234c48da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports